module.exports = __webpack_public_path__ + "static/media/minori-logo.deaa8f80.svg";